import React from "react";

import classes from "./styles/style.module.css";
import CheckBoxItem from "./CheckBoxItem";

const CheckFieldsElement = ({
  id,
  req,
  title,
  subtitle,
  desc,
  selectionList,
  value,
  handleChange,
  formId,
  fieldId,
  disabled,
}) => {
  const selectedCheckboxes = value ? value.split("_") : [];

  const handleCheckboxChange = (_, itemTitle, isChecked) => {
    const updatedSelection = isChecked
      ? [...selectedCheckboxes, itemTitle]
      : selectedCheckboxes.filter(title => title !== itemTitle);
    handleChange(id, updatedSelection.join("_"));
  };

  return (
    <div className="my-4">
      <div>
        <p className={classes.formTitle}>
          {title} <span className="text-danger">{req ? "*" : null}</span>
        </p>
      </div>
      <div className="px-2">
        {subtitle && <p className={classes.subTitle}>{subtitle}</p>}
        {selectionList &&
          selectionList.map((item) => (
            <CheckBoxItem
              handleCheckboxChange={handleCheckboxChange}
              item={item}
              checked={selectedCheckboxes.includes(item.title)}
              disabled={disabled}
              formId={formId}
              key={item._id}
              fieldId={fieldId}
            />
          ))}
        {desc && <p className={classes.desc}>{desc}</p>}
      </div>
    </div>
  );
};

export default CheckFieldsElement;
